import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@spartacus/core';
import { TooltipTextComponent } from '../../../tooltip-text/tooltip-text.component';

@Component({
  selector: 'app-dealer-list-details',
  templateUrl: './dealer-list-details.component.html',
  styleUrls: ['./dealer-list-details.component.scss', '../dealer-list.component.scss'],
  imports: [TooltipTextComponent, TranslatePipe],
})
export class DealerListDetailsComponent implements OnInit {
  @Input() list: any;
  @Input() isShipTo = false;

  constructor() {}

  ngOnInit(): void {}
}
